import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

export interface AssignProxyRequest {
  productId: string;
  proxyOwners: { Name: string; Email: string }[];
}

interface AssignProxyState {
  isLoading: boolean;
  data: AssignProxyRequest | null;
  error: string | null;
}

const initialState: AssignProxyState = {
  isLoading: false,
  data: null,
  error: "",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const assignProxy = createAsyncThunk<any, AssignProxyRequest>(
  "CTDBAssignProxySlice/assignProxy",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("/db/product/user", {
        ProductId: requestDetails.productId,
        ProxyOwners: requestDetails.proxyOwners.map((owner) => ({
          Name: owner.Name,
          Email: owner.Email,
        })),
      });
      const successStatusCodes = [200, 201, 202];
      if (
        !successStatusCodes.includes(response.status) ||
        response.data.Status !== "success"
      ) {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to update proxy owners.",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.error("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to update proxy owners.",
      });
    }
  }
);

const CTDBAssignProxySlice = createSlice({
  name: "CTDBAssignProxySlice",
  initialState,
  reducers: {
    resetAssignProxyState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(assignProxy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        assignProxy.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        assignProxy.rejected,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetAssignProxyState } = CTDBAssignProxySlice.actions;

export default CTDBAssignProxySlice.reducer;
